/**
 * Web runtime configuration (Cedar removal, Stages 1.7 and 4.1b). The API
 * prefix is a vite `define` from tools/vite/env.mjs (`defineFor`):
 * `/.redwood/functions` under the dev server (vite proxies it to the api with
 * the prefix stripped) and `/api` in a build (the web tier's proxy prefix in
 * production); web/jest.config.js defines it as `''` for tests, so requests
 * in tests are relative (`/graphql`, `/auth`). This replaced Cedar's
 * `RWJS_ENV` object, which its packages read at import time.
 */
declare const __TWODOTS_API_URL__: string

/** Base path or origin of the API: `${API_URL}/upload`, `${API_URL}/auth`, ... */
export const API_URL: string = __TWODOTS_API_URL__

/** The GraphQL endpoint. */
export const GRAPHQL_URL = `${API_URL}/graphql`

/** The document title's base (`X | Two Dots`); Cedar read it from redwood.toml. */
export const APP_TITLE = 'Two Dots'
